import { Autocomplete, Checkbox, FormControlLabel, Grid, Paper, TextField } from "@mui/material";
import FormHelperText from "@mui/material/FormHelperText";
import { useState } from 'react';
import { FeaturesModel } from '../../models/features.model';
import { FeatureType, PlanFeature } from '../../models/plans.model';

interface Props extends PlanFeature {
    index: number;
    isAddon: boolean;
    allFeaturesData: FeaturesModel[];
    symbolsArr: any[];
    Features: any[];
    onRemove: (id: string) => void;
    handleFields: (name: any, value: any) => void;
    errors: { Label: string, Type: string, Value: string };
    FeatureDragStarted: boolean;
    HandleFeatureDragStart: (id: string) => void;
    HandleFeatureHover: (dragIndex: number, hoverIndex: number) => void;
    DraggingFeatureID: string;
    IsMobileDevice?: boolean;
    HandleFeatureChangeCompletion?: (id: string, isValid: boolean, feature?: any) => void
}

interface FeatureDragItem {
    index: number;
    id: string;
    type: string;
}

interface State extends PlanFeature {
    subFeatures: FeaturesModel[];
    errors: { Label: string, Type: string, Value: string }
    [key: string]: any;
}

const AddFeatureAddOn = (props: Props) => {
    const [subFeatures, setSubFeatures] = useState(props.allFeaturesData.filter((item: FeaturesModel) => item.Type === FeatureType.MAIN));
    const [errors, setErrors] = useState(props.errors);
    const [Value, setValue] = useState(props.Value);
    const [ID, setID] = useState(props.ID);
    const [Validity, setValidity] = useState(props.Validity);

    const handleSubFeature = (e: any, value: any) => {
        let errorsSub = errors;
        let typeFeature = { ...props.Features[props.index] };
        if (value) {
            typeFeature = { ...typeFeature, Label: value.Name, ID: value.ID }
            errorsSub.Label = "";
            props.handleFields("feature", "")
            setID(typeFeature.ID);
            setErrors(errorsSub);
            if (typeFeature.ID) {
                setValue('');
            }
            props.HandleFeatureChangeCompletion(typeFeature.ID, (typeFeature.ID !== '' || Value !== ''), typeFeature)
        }
        else {
            props.handleFields("feature", "Required")
            errorsSub.Label = "Required*";
            setID("");
            setErrors(errorsSub);
        }
    }

    const handleCheckedItem = (e: any) => {
        let errorsSub = errors;
        let typeArr = props.Features[props.index]
        typeArr = { ...typeArr, Value: e.target.checked === true ? -1 : "" }
        typeArr.Validity = e.target.checked === true ? -1 : 0
        setValue(e.target.checked === true ? "-1" : "")
        errorsSub.Value = !e.target.checked ? `Required*` : "";
        setValidity(e.target.checked === true ? -1 : 0)
        setErrors({ ...errorsSub })
        if (ID) {
            props.HandleFeatureChangeCompletion(ID, ((!!Value || Validity === -1)), typeArr)
        }
        props.handleFields("feature", e.target.checked)
    }

    const handleInputField = (e: any, id: string) => {
        const inputValue = e.target.value;
        let typeFeature = { ...props.Features[props.index] };
        const regex = /^[0-9]*$/;
        if (!regex.test(inputValue)) {
            e.target.value = inputValue.replace(/[^0-9]/g, '');
            return;
        }
        typeFeature = { ...typeFeature, Value: inputValue }
        const newErrors = {
            ...errors,
            Value: inputValue.trim() === "" ? "Required*" : ""
        };
        props.handleFields("feature",inputValue)
        setValue(inputValue)
        setErrors(newErrors)
        if (ID) {
            const isValid = (!!inputValue || Validity === -1) && inputValue.trim() !== "";
            props.HandleFeatureChangeCompletion(ID, isValid, typeFeature);
        }
    }

    return (
        <Paper className={`d-flex align-center mt-2 p-1 box-shadow-none add-phone-number-paper-border feature-box-shadow mx-1`} >
            <div className={'d-flex w-fill'}>
                {props.Features.length !== 0 &&
                    <>
                        <Grid item xs={6}>
                            <Autocomplete
                                size="small"
                                disableClearable
                                className={"mx-1 my-1 w-fill"}
                                classes={{ input: `h4-regular color-text-field-font`, paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                                options={subFeatures}
                                getOptionDisabled={(option: FeaturesModel) => option.IsDeleted}
                                getOptionLabel={(option: any) => option.Name}
                                onChange={handleSubFeature}
                                value={subFeatures.find(x => x.ID === ID)}
                                renderOption={(defaultprops, option: any) => (
                                    <li {...defaultprops}>
                                        <span className={`${'h4-regular'} c-pointer color-menu-list-font-color p-2 d-flex justify-between w-p-90`}>
                                            {option.Name}
                                        </span>
                                    </li>
                                )}
                                renderInput={(params) => <TextField {...params} name="Label" required variant="outlined" label="Select Feature" placeholder="Select Feature" />}
                            />
                            <FormHelperText className={`h5-regular color-primary-danger t-align-right mr-1`}>
                                {errors.Label}
                            </FormHelperText>
                        </Grid>
                        <Grid item xs={2} className={`my-1`}>
                            <FormControlLabel classes={{ label: "w-space h4-regular color-feature-title" }} className={`mx-auto`}
                                control={
                                    <Checkbox
                                        classes={{ checked: "selected-checkbox" }}
                                        checked={Value === "-1"}
                                        onChange={(e) => handleCheckedItem(e)
                                        }
                                        name="Value"
                                        disabled={!ID}
                                    />}
                                label="Unlimited"
                            />
                        </Grid>
                        <Grid item xs={2}><TextField required type="number" name='Value' variant="outlined" size='small' className={`mx-auto my-1 w-fill`}
                            value={Value === "-1" ? "" : Value}
                            placeholder={"Value"}
                            label={"Value"}
                            disabled={Value === "-1" || !ID}
                            InputProps={{
                                style: {
                                    backgroundColor: Value === "-1" ? 'lightgrey' : !ID ? 'lightgrey' : 'transparent',
                                }
                            }}
                            onChange={e => handleInputField(e, props.ID)}
                            onKeyDown={e => props.symbolsArr.includes(e.key) && e.preventDefault()}
                        />
                            <FormHelperText className={`h5-regular color-primary-danger t-align-right mr-1`}>
                                {errors.Value || ""}
                            </FormHelperText>
                        </Grid>
                    </>}
            </div>
        </ Paper>
    )
}

export default AddFeatureAddOn;